module.exports = __webpack_public_path__ + "static/media/dropzone-vector.3cc5b515.svg";